// Calculate monthly payment and DSCR
export default function calculateMonthlyPmtAndDSCR({
  loanAmount,
  localInterestRate,
  numPmt,
  numYrs,
  annualRent,
  annualTaxes,
  annualInsurance,
  annualHOA,
  loanAmortization = "Fully amortizing", // Default to fully amortizing for backward compatibility
}) {
  let monthlyPmt;

  if (loanAmortization === "Interest only") {
    // Interest-only payment calculation: only pay interest, no principal
    monthlyPmt = (loanAmount * (parseFloat(localInterestRate) / 100)) / 12;
  } else {
    // Fully amortizing payment calculation (original formula)
    monthlyPmt =
      (loanAmount *
        (parseFloat(localInterestRate) / 100 / numPmt) *
        (1 + parseFloat(localInterestRate) / 100 / numPmt) **
          (numYrs * numPmt)) /
      ((1 + parseFloat(localInterestRate) / 100 / numPmt) ** (numYrs * numPmt) -
        1);
  }

  // DSCR calculation
  // (Rent - Utilities - Maintenance - Property Management) ÷ (Mortgage Pay + Taxes + Insurance + HOA)
  const dscr =
    parseInt(annualRent) /
    (parseInt(monthlyPmt * 12) +
      parseInt(annualTaxes) +
      parseInt(annualInsurance) +
      parseInt(annualHOA));

  return { monthlyPmt, dscr };
}
